import React from "react"
import { useStaticQuery, graphql } from "gatsby"

import QaList from "../qaList"
import { H4 } from "../typography"
import { FeatureContainer } from "../features/styled"

const PricingQa = () => {
  const data = useStaticQuery(graphql`
    {
      yaml: contentYaml(header: { slug: { eq: "/pricing" } }) {
        content {
          faq {
            title
            list {
              q
              a
            }
          }
        }
      }
    }
  `)
  const { title, list } = data.yaml.content.faq

  return (
    <FeatureContainer direction="vertical">
      <H4>{title}</H4>
      <QaList items={list} />
    </FeatureContainer>
  )
}

export default PricingQa
